import fetch from 'isomorphic-fetch';
import getBrowserLanguage from '../utils/languageDetector';

export const setInviteInfo = (inviteInfo) => ({
  type: 'INVITE_INFO',
  payload: { inviteInfo },
});

export const setRegisterErrors = (errors) => ({
  type: 'REGISTER_ERRORS',
  payload: { errors },
});

export const clearInvite = () => ({
  type: 'CLEAR_INVITE',
});

export const performRegistration = (user) => async (dispatch) => {
  const {
    antibot,
    email,
    password,
    firstName,
    lastName,
    middleName,
    phone,
    position,
    companyName,
    companyBranch,
    token,
    tokenLink,
    partnerToken,
    successRedirect = null,
    roles,
  } = user;
  const res = await fetch('/auth/local/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: antibot || '',
      email,
      password,
      firstName,
      lastName,
      middleName,
      phone,
      position,
      companyName,
      companyBranch,
      language: getBrowserLanguage(),
      inviteToken: token,
      tokenLink,
      partnerToken,
      successRedirect,
      roles,
    }),
  });
  const parsedRes = await res.json();
  if (res.status > 200) {
    if (parsedRes.errors && parsedRes.errors.length) {
      dispatch(setRegisterErrors(parsedRes.errors));
    }
  }
  return { ok: res.ok, json: parsedRes };
};

export const getInviteData = (token) => async (dispatch) => {
  // eslint-disable-line
  try {
    const res = await fetch(`/api/invites/info/${token}`);
    if (res.status > 200) {
      return Promise.reject();
    }
    const inviteInfo = await res.json();
    return dispatch(setInviteInfo(inviteInfo));
  } catch (e) {
    return console.error(e);
  }
};



// WEBPACK FOOTER //
// ./action-creators/registration.js